// 体质调理方案模块
// 负责所有围绕 module_list / description_list 的清洗，
// 同时被 Adjustment / Feature / Tendency 共用 module.data 渲染的视图所依赖。
//
// 处理内容：
//   1. flow_step==19：合并倾向体质的 module_list_qingxiang 到 module_list
//   2. sys_company_id==84 且非 flow_step==19：把倾向体质的 description_list 并入主 description_list
//   3. 按体质顺序重排每个模块的 description_list
//   4. 默认展开第一项 + 子项第一条 active

export default function transform(data) {
    if (!data) return;
    const module_list = data.module_list;
    if (!Array.isArray(module_list)) return;

    const isFlowStep19 = Number(data.flow_step) === 19 || Number(data.flow_step) === 20;
    const tizhi_content = data.tizhi_content;

    // 排序所用的体质顺序：以主体质 physique 为基础
    // 注：sys_company_id==84 非 flow_step==19 情况下，Physique/transform 已先把倾向体质 concat 到 physique，
    // 这里 slice 后会包含倾向体质，从而让倾向体质的 description_list 也获得 .index 索引；
    // 视图 `index == 0 ? '主' : '兼'` 的渲染结果不受影响。
    let tizhiSortList =
        tizhi_content && Array.isArray(tizhi_content.physique)
            ? tizhi_content.physique.slice()
            : [];

    // 1) flow_step==19：合并倾向体质模块到主 module_list
    if (isFlowStep19) {
        const module_list_qingxiang = Array.isArray(data.module_list_qingxiang)
            ? data.module_list_qingxiang
            : [];
        const tizhi_qingxiang_text_array = Array.isArray(data.tizhi_qingxiang_text_array)
            ? data.tizhi_qingxiang_text_array
            : [];

        for (let uu = 0, jj = module_list_qingxiang.length; uu < jj; uu++) {
            const qingxiang_module = module_list_qingxiang[uu];
            let hasModule = false;
            for (let u1 = 0, j1 = module_list.length; u1 < j1; u1++) {
                if (module_list[u1].module_name == qingxiang_module.module_name) {
                    module_list[u1].description_list = {
                        ...module_list[u1].description_list,
                        ...qingxiang_module.description_list
                    };
                    hasModule = true;
                }
            }
            if (!hasModule) module_list.push(qingxiang_module);
        }

        for (let uu = 0, jj = tizhi_qingxiang_text_array.length; uu < jj; uu++) {
            if (!tizhiSortList.includes(tizhi_qingxiang_text_array[uu])) {
                tizhiSortList.push(tizhi_qingxiang_text_array[uu]);
            }
        }
    }

    // 2) sys_company_id==84 且非 flow_step==19：把倾向体质的 description_list 并入主 description_list
    if (tizhi_content && data.sys_company_id == 84 && !isFlowStep19) {
        const physique_qingxiang = tizhi_content.physique_qingxiang;
        const module_list_qingxiang = data.module_list_qingxiang;
        if (
            Array.isArray(physique_qingxiang) && physique_qingxiang.length > 0
            && Array.isArray(module_list_qingxiang)
        ) {
            for (let uu = 0, jj = module_list.length; uu < jj; uu++) {
                for (let u1 = 0, j1 = module_list_qingxiang.length; u1 < j1; u1++) {
                    if (module_list[uu].module_name == module_list_qingxiang[u1].module_name) {
                        for (let u2 = 0, j2 = physique_qingxiang.length; u2 < j2; u2++) {
                            const pq = physique_qingxiang[u2];
                            module_list[uu].description_list[`${pq}`] =
                                module_list_qingxiang[u1].description_list[`${pq}`];
                        }
                    }
                }
            }
        }
    }

    // 3) 按体质顺序重排每个模块的 description_list
    if (tizhi_content) {
        for (let u = 0, j = module_list.length; u < j; u++) {
            const description_list = {};
            const current_description_list = module_list[u].description_list || {};
            const sort_list = tizhiSortList.length > 0 ? tizhiSortList : tizhi_content.physique;
            for (let z = 0, t = sort_list.length; z < t; z++) {
                if (current_description_list[sort_list[z]]) {
                    description_list[sort_list[z]] = current_description_list[sort_list[z]];
                    description_list[sort_list[z]].index = z;
                }
            }
            for (const description in current_description_list) {
                if (!description_list[description]) {
                    description_list[description] = current_description_list[description];
                }
            }
            module_list[u].description_list = description_list;
        }
    }

    // 4) 默认展开第一项 + 子项第一条 active
    for (let i = 0, n = module_list.length; i < n; i++) {
        const description_list = module_list[i].description_list;
        let hoo = 0;
        for (const description in description_list) {
            if (hoo == 0) {
                description_list[description].active = true;
            }
            if (description_list[description].list) {
                description_list[description].list[0].active = true;
            }
            hoo++;
        }
    }
}
